import { getCurrentLocale } from './dateFormatter';

/**
 * Formate un montant en devise selon la locale
 * @param {number|string|null|undefined} value - Montant à formater
 * @param {string} currency - Code devise (par défaut 'EUR')
 * @param {object} options - Options de formatage
 * @param {boolean} options.showDecimals - Afficher les décimales (par défaut: false pour EN, true pour FR)
 * @returns {string} Montant formaté
 */
export const formatCurrency = (value, currency = 'EUR', options = {}) => {
  if (value === null || value === undefined) return '--';
  
  const numeric = typeof value === 'number' ? value : parseFloat(String(value));
  if (Number.isNaN(numeric)) return '--';
  
  const locale = getCurrentLocale();
  const { showDecimals = locale === 'fr' } = options;
  
  if (locale === 'en') {
    // Format anglais: €1,234.56 (avec décimales seulement si nécessaire, max 2)
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    }).format(numeric);
  } else {
    // Format français: 1 234,56 € (avec décimales seulement si nécessaire, max 2)
    // currencyDisplay 'narrowSymbol' => '$' au lieu de '$US', '$' au lieu de '$CA', etc.
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    }).format(numeric);
  }
};

/**
 * Formate un montant sans le symbole de devise (pour affichage personnalisé)
 * @param {number|string|null|undefined} value - Montant à formater
 * @param {object} options - Options de formatage
 * @param {boolean} options.showDecimals - Afficher les décimales
 * @returns {string} Montant formaté sans symbole
 */
export const formatCurrencyAmount = (value, options = {}) => {
  if (value === null || value === undefined) return '--';
  
  const numeric = typeof value === 'number' ? value : parseFloat(String(value));
  if (Number.isNaN(numeric)) return '--';
  
  const locale = getCurrentLocale();
  const { showDecimals = locale === 'fr' } = options;
  
  if (locale === 'en') {
    // Format anglais: 1,234 (virgule comme séparateur de milliers, pas de décimales)
    const rounded = Math.round(numeric);
    return rounded.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  } else {
    // Format français: 1 234,00 (espace comme séparateur de milliers, virgule pour décimales)
    return numeric.toLocaleString('fr-FR', {
      minimumFractionDigits: showDecimals ? 2 : 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    });
  }
};



